import { SERPCardResult } from "shared/types/serpResult";

/**
 * Returns whether an itinerary contains at least one selected airline.
 *
 * An itinerary may be composed of different airlines (for example G3 on the
 * outbound sector and LA on the return sector). Selecting one airline should
 * keep that itinerary when the selected airline operates any of its flights.
 */
export const matchesAirlineFilter = (
  result: Pick<SERPCardResult, "sectors">,
  selectedAirlines: string[],
): boolean => {
  if (selectedAirlines.length === 0) return false;

  const itineraryAirlines = new Set(
    result.sectors.flatMap((sector) =>
      sector.flights.map((flight) => flight.airline),
    ),
  );

  return selectedAirlines.some((airline) => itineraryAirlines.has(airline));
};
